export default {
	nutritionnaissaince3ans: {
		title: '<sup>[PDF]</sup> La nutrition de la naissance à 3 ans',
		link: 'http://inpes.santepubliquefrance.fr/CFESBases/catalogue/pdf/890.pdf'
	},
	allaitementmaternel: {
		title: '<sup>[PDF]</sup> L\'allaitement maternel',
		link: 'https://www.santepubliquefrance.fr/determinants-de-sante/nutrition-et-activite-physique/documents/brochure/le-guide-de-l-allaitement-maternel'
	},
	alimentation0a3ans: {
		title: 'L\'alimentation de l\'enfant de 0 à 3 ans',
		link: 'https://www.ameli.fr/paris/assure/sante/themes/alimentation-0-3-ans'
	},
	alimentation3a18ans: {
		title: 'L\'alimentation de l\'enfant de 3 à 18 ans',
		link: 'https://www.ameli.fr/paris/assure/sante/themes/alimentation-3-18-ans'
	},
	activitephysique: {
		title: 'A chaque âge son activité physique',
		link: 'https://www.ameli.fr/paris/assure/sante/themes/activite-physique-sante/age-activite-physique'
	},
	depistageenfant: {
		title: 'Dépistage et suivi de l\'enfant et de la mère après l\'accouchement',
		link: 'https://www.ameli.fr/paris/assure/sante/themes/accouchement-nouveau-ne/depistage-neonatal-suivi-mere-bebe'
	},
	mtdent: {
		title: 'En savoir plus sur MT\'Dents tous les ans !',
		link: 'https://www.ameli.fr/paris/assure/sante/themes/carie-dentaire/mt-dents'
	},
	calendriervaccinations: {
		title: '<sup>[PDF]</sup> Calendrier des vaccinations',
		link: 'https://www.ameli.fr/assure/remboursements/rembourse/medicaments-vaccins-dispositifs-medicaux/vaccination'
	},
	vaccinsobligatoires: {
		title: 'Vaccins obligatoires',
		link: 'https://www.ameli.fr/paris/assure/sante/themes/vaccination/vaccins-obligatoires'
	},
	accompagnepremier: {
		title: '<sup>[PDF]</sup>J\'accompagne les premiers pas de mon enfant',
		link: 'https://www.ameli.fr/sites/default/files/Documents/4086/document/premiers-pas_assurance-maladie.pdf'
	}
};
